module.exports = __webpack_public_path__ + "img/diet-2.c4d8690b.jpg";